<!--<app-preloader></app-preloader>-->
<app-navbar></app-navbar>

<router-outlet></router-outlet>
<!--<app-subscribe></app-subscribe>-->
<app-footer></app-footer>
<app-cookie-consent></app-cookie-consent>
